<template>
  <div id="app" style=" margin-left: auto; margin-right: auto;">
    <b-navbar style="background-color: #34558b;" toggleable="lg">
      <b-navbar-brand style="color: white; font:26px Avenir, Helvetica, Arial, sans-serif; font-weight:bold">
        Haotian Li
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav style="color: white; font:22px Avenir, Helvetica, Arial, sans-serif;" class="ml-auto">
          <b-nav-item style="color: white;" href="#publications">Research</b-nav-item>
          <b-nav-item style="color: white;" href="#experience">Experience</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-container style='padding: 0'>
      <b-col>
        <b-row id="myself" style='padding: 0'>
          <b-col sm="4" id="photo" style='padding: 0'>
            <b-card no-body style="border: 0px">
              <b-card-body>
                <b-avatar src="photo_2.jpg" size="60%"></b-avatar>
              </b-card-body>
              <b-card-body style='padding: 0 0 1.5vw 0'>
                <b-list-group class="socials detail" style="width: 100%; margin-left: 2vw; margin-right: 0; font-size: 16px; ">
                  <b-list-group-item href="mailto:haotian.li@microsoft.com"  style="float: left; border: 0px;text-align:left; padding:0 0 0 2vw"><i><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="envelope" class="svg-inline--fa fa-envelope fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width:20px" transform="translate(0, -2)"><path fill="currentColor" d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"></path></svg></i> haotian.li@microsoft.com
                  </b-list-group-item>
                  <b-list-group-item href="https://github.com/liht1996" style="align-self: start; border: 0px;text-align:left; padding:0 2vw"><i><svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="github" class="svg-inline--fa fa-github fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" style="width:20px;" transform="translate(0, -2)"><path fill="currentColor" d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"></path></svg></i> GitHub
                  </b-list-group-item>
                  <b-list-group-item href="https://scholar.google.com/citations?user=uWwEvlQAAAAJ" style="align-self: start; border: 0px;text-align:left;padding:0 2vw"><i><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="graduation-cap" class="svg-inline--fa fa-graduation-cap fa-w-20 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style="width:20px" transform="translate(0, -2)"><path fill="currentColor" d="M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"></path></svg></i> Google Scholar
                  </b-list-group-item>
                </b-list-group>

              </b-card-body>

            </b-card>
          </b-col>
          <b-col sm="8" id="intro" style='padding: 0' >
            <b-card style="text-align: left; border: 0px; color:black">
              <p style="margin: 1vw 0 1vw 0" ><b>Haotian Li</b> (李昊天) is currently a 
              Researcher in <a href="https://www.microsoft.com/en-us/research/people/haotianli/" target='_blank'  style='color:black'><u>Social Computing Group</u></a> at <a href="https://www.microsoft.com/en-us/research/lab/microsoft-research-asia/" target='_blank'  style='color:black'><u>Microsoft Research Asia</u></a>. Previously, he received his PhD in Computer Science and Engineering from The Hong Kong University of Science and Technology (HKUST), under supervision of <a href='http://huamin.org/' target='_blank' style='color:black'><u>Prof. Huamin Qu</u></a> in <a href='http://vis.cse.ust.hk/' target='_blank' style='color:black'><u>HKUST VisLab</u></a>. Before that, he received his bachelor degree with first class honors from HKUST in 2019, with major in Computer Engineering and minors in Big Data Technology and Business.</p>
              
              <p>His recent research focus is to understand, enhance, and envision effective and safe <b>human-AI collaboration</b> from a human-centered perspective with techniques from human-computer interaction (HCI) and artificial intelligence (AI). He is passionate about integrating the power of humans and AI in <b>productivity</b> and <b>creativity</b> tasks, such as data analysis and storytelling. Previously, he also worked on visual analytics and E-learning.</p>

              <b-card v-if="internRecruitment" no-body class="intern-recruitment-card">
                <b-card-body class="intern-recruitment-body">
                  <div v-html="internRecruitment.Content"></div>
                </b-card-body>
              </b-card>
            </b-card>
          </b-col>
        </b-row>
        <b-row id="news">
          <b-card style="width:100%; border: 0px; padding: 1vw 0 0 0" no-body >
            <b-card-header style="font-size:22px;text-align:left;font-weight:bold;border: 0px;background:white">
              News
            </b-card-header>
            <b-card-body style="border:0px; padding:5px 5px 5px 5vw ">
              <b-list-group v-if="news" > 
                <news v-for="(d, i) in news.slice(0, 6)" :key="'news_'+i" :data='d' />
              </b-list-group>
            </b-card-body>
          </b-card>
        </b-row>
        <b-row id="publications">
          <b-card style="width:100%;border: 0px; padding: 1vw 0 0 0" no-body >
            <b-card-header v-if="publications && publication_years" style="font-size:22px;text-align:left;font-weight:bold;border: 0px;background:white">
              Publications
              <div class="pub-note">*: equal contribution, &dagger;: corresponding author</div>
            </b-card-header>
            <!-- Special Selected Card -->
            <b-card class="selected-card" style="padding:5px;border: 0px" no-body v-if="selectedPapers && selectedPapers.length">
              <b-card-header class="year-header selected-header" @click="toggleSelected">
                <span class="expand-icon">
                  {{ selectedOpen ? '▾' : '▸' }}
                </span>
                 <span>Selected</span>
              </b-card-header>
              <b-collapse :visible="selectedOpen">
                <b-card-body style="padding:5px;border:0px">
                  <b-list-group>
                    <publication v-for="(paper, idx) in selectedPapers" :key="'selected_'+idx" :data="paper" />
                  </b-list-group>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card v-for="i in publication_years" :key="'pubs_'+i" style="padding:5px;border: 0px" no-body>
              <b-card-header 
                class="year-header"
                @click="toggleYear(i)"
              >
                <span class="expand-icon">
                  {{ isYearOpen(i) ? '▾' : '▸' }}
                </span>
                <span>{{i}}</span>
              </b-card-header>
              <b-collapse :visible="isYearOpen(i)">
                <b-card-body style="padding:5px;border:0px">
                  <b-list-group> 
                    <publication v-for="(j, k) in publications[i]" :key="'pub_'+k" :data='j' />
                  </b-list-group>
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-card>
        </b-row>
        <b-row id="awards">
          <b-card style="width:100%;border: 0px; padding: 1vw 0 0 0" no-body >
            <b-card-header v-if="publications" style="font-size:22px;text-align:left;font-weight:bold;border: 0px;background:white">
              Awards and Honors
            </b-card-header>
            <b-card-body style="border:0px; padding:5px 5px 5px 5vw; text-align:left ">
              <b-list-group style="border: 0px"> 
                <experience v-for="(d, i) in awards" :key="'awards_'+i" :data='d' name="awards"/>
              </b-list-group>
            </b-card-body>
          </b-card>
        </b-row>
        <b-row id="experience">
          <b-card style="width:100%;border: 0px; padding: 1vw 0 0 0" no-body >
            <b-card-header v-if="publications" style="font-size:22px;text-align:left;font-weight:bold;border: 0px;background:white">
              Research/Work Experience
            </b-card-header>
            <b-card-body style="border:0px; padding:5px 5px 5px 5vw; text-align:left ">
              <b-list-group style="border: 0px"> 
                <experience v-for="(d, i) in work" :key="'work_'+i" :data='d' name="work"/>
              </b-list-group>
            </b-card-body>
          </b-card>
        </b-row>
        <b-row id="teaching">
          <b-card style="width:100%;border: 0px; padding: 1vw 0 0 0" no-body >
            <b-card-header v-if="publications" style="font-size:22px;text-align:left;font-weight:bold;border: 0px;background:white">
              Teaching Experience
            </b-card-header>
            <b-card-body style="border:0px; padding:5px 5px 5px 5vw; text-align:left ">
              <b-list-group style="border: 0px"> 
                <experience v-for="(d, i) in teaching" :key="'teaching_'+i" :data='d' name="teaching"/>
              </b-list-group>
            </b-card-body>
          </b-card>
        </b-row>
      </b-col>
    </b-container>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

import { BContainer, BRow, BCol, BNavbar, BNavbarBrand, BNavbarNav, BNavItem, BCard, BCardBody, BAvatar, BListGroup, BListGroupItem, BCollapse, BNavbarToggle, BCardHeader } from 'bootstrap-vue'

import News from './components/NewsComponent'
import Publication from './components/PublicationComponent'
import Experience from './components/ExperienceComponent'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import * as axios from "axios"



export default {
  name: 'App',
  components: {
    // HelloWorld
    BContainer,
    BRow,
    BCol,
    BNavbar,
    BNavbarBrand,
    BNavbarNav,
    BNavItem,
    BCard,
    BCardBody,
    BAvatar,
    BListGroup,
    BListGroupItem,
    BCollapse,
    BNavbarToggle,
    News,
    BCardHeader,
    Publication,
    Experience
  },
  data(){
    return {
      news: false,
      internRecruitment: false,
      publications: false,
      publication_years: false,
      awards: false,
      work: false,
      teaching: false,
      openYears: [],
      selectedOpen: true
    }
  },
  computed: {
    selectedPapers() {
      const pubData = this.publications && this.publications.data
        ? this.publications.data
        : this.publications

      if (!pubData) return []

      // Preserve displayed order when possible, but never miss keys.
      const orderedKeys = []
      if (Array.isArray(this.publication_years)) orderedKeys.push(...this.publication_years)
      orderedKeys.push(...Object.keys(pubData))

      const seen = new Set()
      const keys = orderedKeys.filter(k => {
        if (seen.has(k)) return false
        seen.add(k)
        return true
      })

      const selected = []
      for (const key of keys) {
        const papers = pubData[key]
        if (!Array.isArray(papers)) continue
        for (const paper of papers) {
          const flag = paper && paper.selected
          if (flag === true || flag === 'true' || flag === 1 || flag === '1') {
            selected.push(paper)
          }
        }
      }

      return selected
    }
  },
  methods: {
    toggleSelected() {
      this.selectedOpen = !this.selectedOpen
    },
    toggleYear(year) {
      if (this.openYears.includes(year)) {
        this.openYears = this.openYears.filter(y => y !== year)
      } else {
        this.openYears.push(year)
      }
    },
    isYearOpen(year) {
      return this.openYears.includes(year)
    }
  },
  mounted(){
    axios.get("news.json").then(response=>{
        this.news = response.data.data
        this.internRecruitment = response.data.intern_recruitment || false
    })
    axios.get("awards.json").then(response=>{
        this.awards = response.data.data
    })
    axios.get("work.json").then(response=>{
        this.work = response.data.data
    })
    axios.get("teaching.json").then(response=>{
        this.teaching = response.data.data
    })
    axios.get("publication.json").then(response=>{
        this.publications = response.data.data
        this.publication_years = Object.keys(response.data.data)
        this.publication_years.sort((a,b)=>{
          if (a=="Before 2019" || a=="Preprint"){
            return 1
          }
          else{
            if (a < b){
              return 1
            }
            else{
              return -1
            }
          }
        })
        // Default open the most recent three years
        this.openYears = this.publication_years.slice(0, 3)
    })
  }
}
</script>

<style>

.selected-card {
  border: 0;
  background: transparent;
  border-radius: 8px;
}
.intern-recruitment-card {
  margin-top: 12px;
  border: 0;
  border-radius: 0;
}
.intern-recruitment-body {
  padding: 0;
  color: #cb181d;
}
.intern-recruitment-body a {
  color: #cb181d !important;
}

.pub-note {
  font-size: 14px;
  font-weight: bold;
  color: #6c757d;
  margin-top: 4px;
}
.year-header.selected-header {
  background: #fff3bf;
  color: #b8860b;
}
.year-header.selected-header:hover {
  background: #ffec99;
}

.year-header {
  font-size: 18px;
  text-align: left;
  font-weight: bold;
  border: 0px;
  background: #f0f4fa;
  margin: 0vw 4.7vw;
  cursor: pointer;
  display: block;
  transition: background 0.2s;
  border-radius: 8px 8px 0 0;
  box-sizing: border-box;
}
.year-header > .expand-icon,
.year-header > span:last-child {
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
}
.year-header:hover {
  background: #e0e8f5;
}
.expand-icon {
  margin-right: 10px;
  font-size: 22px;
  width: 1.2em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 600px) {
  .year-header {
    padding-left: 3vw;
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

@media (min-width: 1800px){
  .container, .container-sm, .container-md, .container-lg, .container-xl {
      max-width: 1640px;
  }
}

@media (min-width: 1080px){
  .container, .container-sm, .container-md, .container-lg, .container-xl {
      max-width: 1300px;
  }
  #app {
    width: 70%;
  }
}

@media (max-width: 1080px){
  #app {
    width: 100%;
  }
}


.all-card {
  margin: 0;
}

.nav-link {
  color: white !important;
  font-size: 18px
}


</style>
